import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import Image from '../../assets/img/blog/blog-sidebar-1.jpg';

const SingleBlogThree = (props) => {
  const {
    itemClass,
    blogImage,
    authorName,
    publishedDate,
    commentCount,
    viewCount,
    title,
    description,
    btnText,
  } = props;

  return (
    <div className={itemClass ? itemClass : 'postbox-thumb-box mb-80'}>
      <div className="postbox-main-thumb mb-35">
        <img src={blogImage ? blogImage : Image} alt="" />
      </div>
      <div className="postbox-content-box">
        <div className="postbox-meta mb-20">
          <span>
            <i className="flaticon-user-1"></i>
            {authorName ? authorName : 'Alrejaof'}
          </span>
          <span>
            <i className="flaticon-clock"></i>
            {publishedDate ? publishedDate : 'Dec 28, 2022'}
          </span>
          <span>
            <i className="flaticon-chat"></i>(
            {commentCount ? commentCount : '04'}) Coments
          </span>
          <span>
            <i className="flaticon-view"></i>
            {viewCount ? viewCount : '1,526'} views
          </span>
        </div>
        <h4 className="postbox-title">
          <Link to="/blog-details">
            {title ? title : 'Preserving Care Strategy Amidst Food Changes'}
          </Link>
        </h4>
        <p className="mt-15 mb-30">
          {description
            ? description
            : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris.`}
        </p>
        <Link className="it-btn-theme mr-30" to="/blog-details">
          <Button btnText={btnText ? btnText : 'View all items'} />
        </Link>
      </div>
    </div>
  );
};

export default SingleBlogThree;
